export const ReportUrls = {
  AcademiesDashboard:
    "https://app.powerbi.com/reportEmbed?reportId=60a2ecb4-6dd4-4f08-89ae-b7c04d45ddaa&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
  BenchmarkDashboard:
    "https://app.powerbi.com/reportEmbed?reportId=b40ef78d-7a17-4bb5-b797-56a8a78cc5d8&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
  SkillCloudDashboard:
    "https://app.powerbi.com/reportEmbed?reportId=5aad654e-155d-494f-a7e7-b0f71be489b0&autoAuth=true&ctid=5b973f99-77df-4beb-b27d-aa0c70b8482c",
};
